var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/*
    06/14/2020 - Suhas

    This is a slider to show Purchase Price in Rate-Quote slider.

    Following are the changes done from its original implementation:
    - DownPayment is seperated out from PurchasePrice
    
*/

import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from "react-redux";
import { PurchasePriceUpdate, ShowButtons } from "../store/actions";

import { UserSession } from 'usersession';

var scrollToRef = function scrollToRef(ref) {
    return window.scrollTo(0, ref.current.offsetTop, { behavior: 'smooth' });
};
// General scroll to element function

export default function LoanAmount() {
    var _useState = useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        purchasePrice = _useState2[0],
        setPurchasePrice = _useState2[1];

    var dispatch = useDispatch();
    var purchasePriceRedux = useSelector(function (state) {
        return state.nameReducer.purchasePrice;
    });

    var userSession = new UserSession();

    var myRefPurchase = useRef(null);

    useEffect(function () {
        //This function scroll the slider into view

        // REACT-69: updated condition when NOT to scroll
        !localStorage.getItem('doNotScroll') && scrollToRef(myRefPurchase);
    }, []);

    useEffect(function () {
        dispatch(ShowButtons(true));
        document.getElementById("next-button").disabled = false;

        setPurchasePrice(purchasePriceRedux);

        userSession.setPurchasePrice(purchasePriceRedux);

        if (purchasePrice.length > 0) dispatch(ShowButtons(true));
    }, [purchasePrice]);

    return React.createElement(
        Row,
        { className: 'd-flex justify-content-center text-left pt-1' },
        React.createElement(
            Col,
            { lg: 12 },
            React.createElement(
                'h2',
                { className: 'p-0 d-flex justify-content-center' },
                'Purchase Price'
            )
        ),
        React.createElement(
            Form.Group,
            { as: Col, lg: 6 },
            React.createElement(NumberFormat, { ref: myRefPurchase, className: 'form-control',
                placeholder: 'Purchase Price',
                value: purchasePrice, displayType: 'input',
                thousandSeparator: true, prefix: '$',
                decimalScale: 0, fixedDecimalScale: false,
                onValueChange: function onValueChange(values) {
                    setPurchasePrice(values.value);dispatch(PurchasePriceUpdate(values.value));
                } })
        )
    );
}